export class VotingItemCreateEditData {
  projectTemplate: string;
  action: string;
  projectId: number;
  votingItemId?: number;
  nextItemNumber: string;
}
